import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// Icons
import 'font-awesome/css/font-awesome.min.css';

// Navigation
import { useNavigate, Navigate, Link, useParams } from 'react-router-dom';

// Helpers
import Helpers from '../../helpers';

// Css
import '../../assets/css/app.css';

// Layout
import CommerceLayout from '../layouts/CommerceLayout';

// Components
import LoginForm from '../../components/LoginForm';

@inject('AuthStore', 'OrderStore')
@observer
class OrderDetails extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
        if (this.props.OrderStore.orderDatas[this.props.id] === undefined) {
            Helpers.getOrder(this.props.id)
        }
    }

    render() {
        const details = this.props.OrderStore.orderDatas[this.props.id];

        let orderDetails: any = {
            grandTotal: 0,
            discountAmount: 0
        }

        let products: any = null;

        if (details !== undefined) {
            products = details.products.data.map((product: any) => {
                return {
                    id: product.id,
                    ...product.attributes
                }
            })
        }

        const storeId = localStorage.getItem('storeId');

        return (
            storeId !== null ?
                <CommerceLayout
                    title={Helpers.translation('my_shopping_cart')}
                    visibleCategories={false}
                >
                    {
                        this.props.AuthStore.userData.isLogin ?
                            details !== undefined &&
                            <>
                                <section id="breadcrumbs" className="pt-6 bg-gray-50">
                                    <div className="container mx-auto px-4 text-xs md:text-base">
                                        <ol className="list-reset flex">
                                            <li>
                                                <Link
                                                    className="font-semibold hover:text-primary"
                                                    to={`/home`}
                                                >
                                                    {Helpers.translation('home')}
                                                </Link>
                                            </li>
                                            <li>
                                                <span className="mx-2">&gt;</span>
                                            </li>
                                            <li>
                                                <Link
                                                    className="font-semibold hover:text-primary"
                                                    to={`/orders`}
                                                >
                                                    {Helpers.translation('orders')}
                                                </Link>
                                            </li>
                                            <li>
                                                <span className="mx-2">&gt;</span>
                                            </li>
                                            <li>{details.code}</li>
                                        </ol>
                                    </div>
                                </section>

                                <section id="cart-page" className="bg-white mt-4">
                                    <div className="container mx-auto px-4">
                                        <div className="flex flex-col md:flex-row gap-4">
                                            {/* Cart Items Section */}
                                            <div className="md:w-3/4">
                                                <div className="bg-white rounded-lg shadow-md p-6 mb-4">
                                                    <div className="overflow-x-auto">
                                                        <table className="w-full">
                                                            <thead>
                                                                <tr>
                                                                    <th className="text-center md:text-left font-semibold">{Helpers.translation('product')}</th>
                                                                    <th className="text-center font-semibold">{Helpers.translation('quantity')}</th>
                                                                    <th className="text-center font-semibold">{Helpers.translation('price')}</th>
                                                                    <th className="text-center font-semibold">{Helpers.translation('discount_text')}</th>
                                                                    <th className="text-center md:text-right font-semibold">{Helpers.translation('total')}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    Helpers.objectToArray(details.product_datas).map((productData: any, index: number) => {
                                                                        const productIndex = Helpers.findIndexByCriteria(products, "id", productData.product_id);
                                                                        const product = products[productIndex];
                                                                        const mainImage: any = product.main_image.data !== null ? Helpers.getSmallestImageUrl(product.main_image.data.attributes) : null;

                                                                        orderDetails['grandTotal'] = orderDetails['grandTotal'] + productData.grand_total;
                                                                        orderDetails['discountAmount'] = orderDetails['discountAmount'] + productData.discount_amount;

                                                                        return (
                                                                            <tr
                                                                                key={index}
                                                                                className="pb-4"
                                                                            >
                                                                                <td className="px-1 py-4">
                                                                                    <Link to={`/products/${product.id}`}>
                                                                                        <div className="flex items-center flex-col sm:flex-row text-center sm:text-left">
                                                                                            {
                                                                                                mainImage !== null ?
                                                                                                    <img
                                                                                                        className="h-16 w-16 md:h-24 md:w-24 sm:mr-8 mb-4 sm:mb-0 object-cover"
                                                                                                        src={mainImage}
                                                                                                        alt="Product"
                                                                                                    />
                                                                                                    :
                                                                                                    <img
                                                                                                        className="h-16 w-16 md:h-24 md:w-24 sm:mr-8 mb-4 sm:mb-0 object-cover"
                                                                                                        src={require("../../assets/images/no-image.png")}
                                                                                                        alt="Product"
                                                                                                    />
                                                                                            }

                                                                                            <div>
                                                                                                <p className="text-sm md:text-base md:font-semibold">{product.title}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Link>
                                                                                </td>

                                                                                <td className="px-1 py-4 text-center">
                                                                                    {productData.quantity + ' ' + product.product_unit.data.attributes.title}
                                                                                </td>

                                                                                <td className="px-1 py-4 text-center">
                                                                                    {Helpers.multiplyStringNumber(productData.grand_total, 1) + '' + details.currency.data.attributes.symbol}
                                                                                </td>

                                                                                <td className="px-1 py-4 text-center">
                                                                                    {Helpers.multiplyStringNumber(productData.discount_amount, 1) + '' + details.currency.data.attributes.symbol}
                                                                                </td>

                                                                                <td className="px-1 py-4 text-center">
                                                                                    {Helpers.multiplyStringNumber((productData.grand_total - productData.discount_amount), 1) + '' + details.currency.data.attributes.symbol}
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Summary Section */}
                                            <div className="md:w-1/4 mb-4">
                                                <div className="bg-white rounded-lg shadow-md p-6">
                                                    <h2 className="text-lg font-semibold mb-4">{Helpers.translation('summary')}</h2>

                                                    <div className="flex justify-between mb-4">
                                                        <p className="font-semibold">{Helpers.translation('subtotal')}</p>
                                                        <p>{Helpers.multiplyStringNumber(orderDetails['grandTotal'], 1) + details.currency.data.attributes.symbol}</p>
                                                    </div>

                                                    <div className="flex justify-between mb-4">
                                                        <p className="font-semibold">{Helpers.translation('discount_text')}</p>
                                                        <p>{Helpers.multiplyStringNumber(orderDetails['discountAmount'], 1) + details.currency.data.attributes.symbol}</p>
                                                    </div>

                                                    <div className="flex justify-between mb-2">
                                                        <p className="font-semibold">{Helpers.translation('total')}</p>
                                                        <p>{Helpers.multiplyStringNumber((orderDetails['grandTotal'] - orderDetails['discountAmount']), 1) + details.currency.data.attributes.symbol}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </>
                            :
                            <LoginForm
                                message={Helpers.translation('you_need_login_for_view_this_page')}
                            />
                    }
                </CommerceLayout>
                :
                <Navigate to="/" replace={true} />
        )
    }
}

function WithNavigate(props: any) {
    let navigate = useNavigate();
    const { id } = useParams();

    props = {
        ...props,
        id
    }

    return <OrderDetails {...props} navigate={navigate} />
}

export default WithNavigate